import httpService from '@Utils/httpService';

const baseUrl = 'api/baseTags';

export default {
  search(data, abortController = null) {

    return httpService.post({
      url: `${baseUrl}/search`,
      data,
      signal: abortController?.signal
    });
  },
  masterTagsTypeHead(params) {
     return httpService.get({
          url: `${baseUrl}/master/typeHead`,
          params,
        });
  },
    typeHead(params) {
     return httpService.get({
          url: `${baseUrl}/typeHead`,
          params,
        });
  },
  isolate(data, abortController = null) {
    return httpService.post({
      url: `${baseUrl}/isolate`,
      data,
      signal: abortController?.signal
    });
  },
    matchByName(tagList) {
  return httpService.post({
        url: `${baseUrl}/match`,
        data:tagList,
      });
  },
  getDistinctPropertyValues(assetId, property, search = '') {
    return httpService.post({
      url: 'api/AMIS/inspections/distinctValues',
      data: { assetId, property, search }
    });
  },
  getFilterableProperties() {
    return httpService.get({
      url: 'api/AMIS/inspections/filterableProperties'
    });
  },
};
